import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Ship from '@/assets/icons/ship.svg?inline';
import IconPinFilled from '@/assets/icons/pin-filled.svg?inline';
import ResponsiveImageRatio from '@/components/ResponsiveImageRatio/ResponsiveImageRatio.vue';
import { ImageWidths } from '@/common/interfaces/SizeBreakpoints';
import ShipCard from '@/common/interfaces/modules/ShipCard';

const ShipCardProps = Vue.extend({
  props: { card: Object as () => ShipCard },
});

@Component({
  components: {
    Ship,
    IconPinFilled,
    ResponsiveImageRatio,
  },
})
export default class ShipCardComponent extends ShipCardProps {
  imageWidths: ImageWidths = {
    def: 463,
    sizes: {
      sm: 636,
      md: 992,
      lg: 793,
      xl: 993,
    },
  };

  get cardLocations() {
    return this.card.Locations ? this.card.Locations.join(', ') : '';
  }
}
